import { IState } from '../../../../../store';
import * as Formatters from '../../../../../utils/bargain_terms_formatter';
import { extractUndefinedValue } from '../../../../../utils/extractUndefinedValue';
import { FOfferType, getOfferType } from '../../../../../utils/offer_type';
import { getIsAgentAuthorised } from '../utils/getIsAgentAuthorised';
import { getIsAreaParts } from '../utils/getIsAreaParts';

type Term = [string, string | string[]];
type Terms = Array<Term>;

export function mapSaleTerms(state: IState): Terms {
  const {
    offerData: { offer, user },
  } = state;
  const { bargainTerms, vatPriceTotalRur, minVatPriceTotalRur, pricesPerSquareMeter } = offer;

  const { vatType, agentBonus, contractType } = bargainTerms;

  const pricesPerSquareMeterRur = extractUndefinedValue(pricesPerSquareMeter?.rur);
  const isAreaParts = getIsAreaParts(offer);
  const isAgentAuthorised = getIsAgentAuthorised(user);
  const offerType = getOfferType(offer);

  const terms = Array.of<Term>(
    ['Цена', Formatters.priceFormatter(offer)],
    ['Ставка', Formatters.AreaPerUnitFormatter(pricesPerSquareMeterRur, isAreaParts)],
  );

  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-143094, будет удалён в задаче CD-143198
   */
  const isCommercialNewVatTextEnabled = state.featureToggle.isCommercialNewVatTextEnabled;

  if (offerType !== FOfferType.Garage) {
    terms.push([
      'Налог',
      Formatters.vatTypeFormatter(vatType, vatPriceTotalRur, minVatPriceTotalRur, isCommercialNewVatTextEnabled),
    ]);
  }

  if (offerType !== FOfferType.Business) {
    terms.push(['Тип сделки', Formatters.formatPPA(contractType)]);
  }

  if (isAgentAuthorised) {
    terms.push(['Бонус агенту', Formatters.agentBonus(agentBonus)]);
  }

  return terms;
}
